import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { ACCEPTED_FILES, LANGUAGE_NAMES, DEFAULT_LANGUAGE } from '../../../../service/constants';

const GuideSection = ({ fascicle, onFileChange, error, lang = DEFAULT_LANGUAGE }) => {
    const languageLabel = LANGUAGE_NAMES[lang] || "";
    const languageSuffix = ` (${languageLabel})`;
    
    return (
        <div className="form-group">
            <label>Guía descargable{languageSuffix}</label>
            {fascicle && (
                <div className="mb-2">
                    <object type="application/pdf" data={fascicle} width="400" height="400" />
                </div>
            )}
            <input 
                name="fascicle" 
                onChange={onFileChange} 
                type="file" 
                className="form-control-file" 
                accept={ACCEPTED_FILES} 
            />
            <Alert show={!!error} className="mt-2" variant="danger">{error}</Alert>
        </div>
    );
};

export default GuideSection;
